const MESSAGES = {
  NOT_PERMISSION: "Anh/chị không có quyền thực hiện chức năng này. Vui lòng liên hệ ADMIN để được hỗ trợ",
  DUPLICATE_DOCUMENT:
    "Tên tài liệu trùng với một tài liệu đã có trong hệ thống. Anh/Chị vui lòng điều chỉnh tên tài liệu.",
};

export default MESSAGES;
